import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="oms--filter-toggle"
export default class extends Controller {
  toggleFilter(event) {
    event.preventDefault()
    console.log("Filter toggle clicked") // Debug log
    
    // Try to find the filter overlay controller first
    const filterOverlayContainer = document.querySelector('[data-controller*="oms--filter-overlay"]')
    if (filterOverlayContainer) {
      const controller = this.application.getControllerForElementAndIdentifier(filterOverlayContainer, "oms--filter-overlay")
      if (controller) {
        console.log("Found filter overlay controller, calling openFilter")
        controller.openFilter()
        return
      }
    }
    
    // Fallback: directly manipulate elements
    console.log("Using fallback approach")
    const panel = document.getElementById('filter-overlay-panel')
    const backdrop = document.getElementById('filter-overlay-backdrop')
    
    if (panel && backdrop) {
      // Show elements
      panel.classList.remove('hidden')
      backdrop.classList.remove('hidden')
      
      // Trigger animation
      requestAnimationFrame(() => {
        panel.classList.remove('translate-x-full')
        panel.classList.add('translate-x-0')
      })
      
      // Prevent body scroll
      document.body.classList.add('overflow-hidden')
    }
  }
}